import type { ClientType } from 'types'

import Button from 'components/Button'
import Modal from 'components/Modal'

import copy from 'copy.json'

type Props = {
  clientType: ClientType
  isModalOpen: boolean
  onModalClose: () => void
  onModalConfirmation: () => void
}

const buyer_copy = copy.buyer.demand_details.modal.confirm_edit_demand
const seller_copy = copy.seller.offer_details.modal.confirm_edit_offer
const button = copy.common.button

export default function ConfirmationEditResourceModal({
  clientType,
  isModalOpen,
  onModalClose,
  onModalConfirmation
}: Props) {
  const copy = clientType === 'buyer' ? buyer_copy : seller_copy

  return (
    <Modal isOpen={isModalOpen} onClose={onModalClose} style={{ maxWidth: 400 }}>
      <h3>{copy.title}</h3>
      <p>{copy.description}</p>
      <div style={{ display: 'flex', gap: 16 }}>
        <Button onClick={onModalConfirmation}>{button.confirm}</Button>
        <Button secondary onClick={onModalClose}>
          {button.cancel}
        </Button>
      </div>
    </Modal>
  )
}
